// extracted by mini-css-extract-plugin
export default {"favoriteCard":"favoritesCards_favoriteCard__BHsq+","favoriteTopic":"favoritesCards_favoriteTopic__dHtvY","rating":"favoritesCards_rating__hV9Gb"};